import React, { ReactElement } from 'react';
import { Media } from '../../../../structures/models/media/media';
import SimplePhotoGallery from '../../../icon/simple-photo-gallery';
import OptionalListItem from './util/OptionalListItem';

export interface GlanceBreed {
  name: string;
  pluralName: string;
  size_description: string | null;
  lifespan: string | null;
  energy_level: string | null;
  coat_description: string | null;
  shedding: string | null;
  hypoallergenic: number | boolean;
  group: {
    name: string;
  };
  alternative_breed_names: string[];
  secondary_gallery: Media[];
}

interface BreederGlanceProps {
  breed: GlanceBreed;
  breedNamePlural?: string;
}

const BreederGlance: React.FC<BreederGlanceProps> = ({ breed, breedNamePlural = '' }): ReactElement => {
  return (
    <div className="breed-glance main">
      <section className="breed-at-a-glance">
        <div className="container">
          <div className="row">
            <div className="col col-12 col-lg-6 order-1 order-lg-0">
              <h2 className="mx-auto glance-gead">
                {`${breedNamePlural || breed.name} at a Glance`}
              </h2>
              <ul className="mx-auto glance-gead-list font-awesome-bullets">
                <OptionalListItem
                  className="text-capitalize"
                  label="Size"
                  data={breed?.size_description}
                />
                <OptionalListItem
                  className="text-capitalize"
                  label="Lifespan"
                  data={breed?.lifespan}
                />
                <OptionalListItem
                  className="text-capitalize"
                  label="Energy Level"
                  data={breed?.energy_level}
                />
                <OptionalListItem
                  className="text-capitalize"
                  label="Coat"
                  data={breed?.coat_description}
                />
                <OptionalListItem
                  className="text-capitalize"
                  label="Shedding"
                  data={breed?.shedding}
                />
                <OptionalListItem
                  className="text-capitalize"
                  label="Hypoallergenic"
                  data={breed?.hypoallergenic ? 'Yes' : 'No'}
                />
                <OptionalListItem
                  className="text-capitalize"
                  label="Dog Group"
                  data={breed?.group?.name}
                />
                <OptionalListItem
                  className="text-capitalize"
                  label="Common Nicknames"
                  data={breed?.alternative_breed_names ? breed?.alternative_breed_names.join(', ') : ''}
                />
              </ul>
            </div>
            <div className="col col-12 col-lg-6 order-0 order-lg-1 m-auto glance-puppy-img">
              <SimplePhotoGallery
                photos={breed.secondary_gallery}
                alt={`${breed.name} Example Puppy`}
                maxToDisplay={4}
                useFullTransform
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BreederGlance;
